"use client"

import React from 'react'
import styles from './styles.module.scss'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import { useCurrentProduct } from '@/src/context/product/current-product-context'
import SvgSale from '@/src/assets/svgs/collection/sale.svg'
import { usePromotion } from '@/src/context/promotion/promotion-context'
import { PromotionHelper } from '@/src/helpers/promotion'

export default function ProductHeader() {
    const { merchantSummary } = useMerchant()
    const { titleSizeProduct, currentProduct } = useCurrentProduct()
    const { promotion } = usePromotion()

    const promotionProduct = PromotionHelper.getProduct(promotion, currentProduct?.id ?? '')

    return (
        <>
            <div className={styles.container} id='modal-product-header'>
                <div className={styles.productInfo}>
                    <div className={styles.titleArea}>
                        {promotionProduct && <SvgSale className={styles.svgSales} />}
                        <h3 className={`${styles.name} font-lg`}>{titleSizeProduct ?? currentProduct?.name}</h3>
                    </div>
                    {
                        merchantSummary?.showProductDescription
                            ?
                            <p className={`font-xmd ${styles.description}`}>{currentProduct?.description ?? ""}</p>
                            :
                            <></>
                    }
                </div>
            </div>
        </>
    )
}
